import { instance } from '../instance';
import { getApiUrl } from '@utils';

export async function getSingleTable({ tableId }) {
  const requestConfig = {
    method: 'get',
    url: `${getApiUrl()}/tables/${tableId}`,
    headers: {
      'Content-Type': 'application/json',
    },
    withCredentials: true,
  };

  const res = await instance(requestConfig);
  return res;
}
